import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { JobStage } from '../../index';
import { faArrowRight, faCheck } from '@fortawesome/pro-light-svg-icons';

interface InterviewPlanSectionProps {
    title: string;
    jobStages: JobStage[];
}

interface StatusTypeMap {
    [key: string]: string;
}

const statusClasses: StatusTypeMap = {
    done: 'interviewDone',
    current: 'interviewCurrent',
    upcoming: 'interviewUpcoming',
};

const InterviewPlanSection: React.FC<InterviewPlanSectionProps> = ({ title, jobStages }) => {
    return (
        <>
            <h3 className="heading-2">{title}</h3>
            <ul className="stageContainer">
                {jobStages.map((item) => (
                    <li key={item.id} className={`${statusClasses[item.status] ?? ''}`}>
                        <div className="stageIcon">
                            <FontAwesomeIcon icon={item.status === 'done' ? faCheck : faArrowRight} />
                        </div>
                        {item.name}
                    </li>
                ))}
            </ul>
        </>
    );
};

export default InterviewPlanSection;
